export const general = {
  company: "Company",
  login: "Login",
  logout: "Logout",
  profile: "Profile",
  language: "Language",
  search: "Search",
  cancel: "Cancel",
  add: "Add",
  firstName: "First Name",
  lastName: "Last Name",
  email: "Email",
  role: "Role",
  image: "Image",
  application: "Application",
  valid: "Valid",
  address: "Address",
  addressNotes: "Address Notes",
  city: "City",
  postalCode: "Postal Code",
  country: "Country",
  phone: "Phone",
  logo: "Logo",
  backOffice: "Back Office",
  home: "Home",
  homePage: "Home Page",
  ourPartners: "Our Partners",
  partners: "Partners",
  customers: "Customers",
  suppliers: "Suppliers",
  workWithUs: "Work With Us",
  uploadFile: "Upload File",
  uploadImage: "Upload Image",
  uploadDocument: "Upload Document",
  setToDefaultImage: "Set to default image",
  upload: "Upload",
  uploadImages: "Upload Images",
  uploadDocuments: "Upload Documents",
  noImages: "No images",
  noDocuments: "No documents",
  cart: "Cart",
  yes: "Yes",
  no: "No",
  myOrders: "My Orders",
  deleteImage: "Delete Image",
  undoDeleteImage: "Undo Delete Image",
  orders: "Orders",
  account: "Account",
  reset: "Reset",
  apply: "Apply",
  openInDesktop: "Please open in desktop",
  mainAppLogo: "Main App Logo",
  footerLogo: "Footer Logo",
  appName: "App Name",
  projectName: "Project Name",
  appConfig: "App Configuration",
  appLogoAltText: "App Logo Alt Text",
  appFooterLogoAltText: "Footer Logo Alt Text",
  footerEuFlagImage: "Footer Eu Flag Image ",
  footerEuFlagImageAltText: "Footer Eu Flag Image Alt Text",
  fundedBy:
    "This project has received funding from the European Union’s Horizon Europe programme under grant agreement No",
  projectRegistrationNumber: "Project Registration Number",
  footerCentralImageContent: "Footer Central Image Content",
  basicData: "Basic Data",
  footerData: "Footer Data",
  socialMedia: "Social Media",
  footerCentralImageSrc: "Footer Central Image Src",
  hasCart: "Has Cart",
  hasMultiLanguage: "Has Multi Language",
  basicInfo: "Basic Info",
  companyName: "Company Name",
  edit: "Edit",
  tabTitle: "Tab Title",
  favicon: "Favicon tab icon (size: 64x64)",
  userRole: "User Role",
  userRoles: "User Roles",
  buyer: "Buyer",
  seller: "Seller",
  hybrid: "Hybrid",
  myRequests: "My Requests",
  createRequest: "Create Request",
  sortBy: "Sort By",
  priceAscending: "Price Ascending",
  priceDescending: "Price Descending",
  resetSorting: "Reset Sorting",
  landingPageBackgroundImageSrc:
    "Landing Page Background Image (min width: 1920)",
  admin: "Admin",
  superAdmin: "Super Admin",
  basicConfiguration: "Basic Configuration",
  syncWithSurplex: "Sync with Surplex",
  sync: "Sync",
  created: "Created",
  updated: "Updated",
  submitted: "Submitted",
  active: "Active",
  userActions: "User Actions",
  uploadFiles: "Upload Files",
  saveAndClose: "Save & Close",
  saveAndContinue: "Save & Continue",
  exit: "Exit",
  continue: "Continue",
  closeAndContinue: "Close & Continue",
  unableToInitializeKeycloak: "Unable to initialize keycloak",
  logs: "Logs",
  getProducts: "Get Products",
  deleteProducts: "Delete Products",
  images: "Images",
  selectedProject: "Selected Project",
  about: "About",
  aboutPage: "About Page",
  aboutImage: "About Image",
  policyFiles: "Policy Files",
  projectLink: "Project Link",
  visitProject: "Visit Project",
  categories: "Categories",
  menu: "Menu",
  homePageUrl: "Home Page Url",
  saving: "Saving",
  loading: "Loading",
  syncedWith: "Synced with",
  errorSyncingWith: "Error syncing with",
  deletedProducts: "Deleted products",
  errorDeletingProducts: "Error deleting products",
  deleted: "Deleted",
  error: "Error",
  added: "Added",
  duration: "Duration",
  fetched: "Fetched",
  thisPropertyWillBeDeleted: "This property will be deleted",
  propertyName: "Property Name",
  colorsSelection: "Colors Selection",
  mainButtonColor: "Main button color",
  mainButtonTextColor: "Main button text color",
  mainButtonHoverColor: "Main button hover color",
  mainButtonHoverTextColor: "Main button hover text color",
  navbarBackgroundColor: "Navbar background color",
  navbarTextColor: "Navbar text color",
  pageNotFound: "Page Not Found",
  goToHome: "Go to Home",
  back: "Back",
  save: "Save",
  submit: "Submit",
  expand: "Expand",
  collapse: "Collapse",
};
